export default __webpack_public_path__ + "static/media/orientation.2c7a4e4f.svg";